import Row from '@app/components/layout/Row'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronUp, faChevronDown } from '@fortawesome/pro-solid-svg-icons'
import { useState } from 'react'

export type CollapsibleSectionProps = {
  title: React.ReactElement
  children: React.ReactNode
  lightIcon?: boolean
  isOpenByDefault?: boolean
}

export const CollapsibleSection = ({
  title,
  children,
  lightIcon = false,
  isOpenByDefault = false,
}: CollapsibleSectionProps) => {
  const [isCollapsed, setIsCollapsed] = useState(!isOpenByDefault)
  const toggle = () => setIsCollapsed((prev) => !prev)
  const icon = isCollapsed ? faChevronDown : faChevronUp
  return (
    <>
      <Row
        style={{
          gap: '0.5rem',
          alignItems: 'center',
          userSelect: 'none',
          cursor: 'pointer',
        }}
        onClick={toggle}
      >
        {title}{' '}
        <FontAwesomeIcon
          icon={icon}
          fontSize={lightIcon ? '1rem' : '1.125rem'}
          fontWeight={lightIcon ? 900 : 400}
          color="#090F3F"
        />
      </Row>
      {!isCollapsed && children}
    </>
  )
}
